import { ComponentType, ElementType, FC, ReactNode } from "react";
import { TEXT_STYLES } from "../../undermaps/styles";

export const userMenuButtonPadding = "px-4 py-1.5";

type MenuItemProps = {
  label?: string;
  HeroIcon?: ComponentType<{
    className?: string;
  }>;
  customIcon?: ReactNode;
  description?: string;
  disabled?: boolean;
};

type MenuButtonOwnProps<E extends ElementType> = {
  as?: E;
  onClick?: () => void;
  "data-action"?: string;
} & MenuItemProps;

const ButtonDefaultAsTypeConst = "button" as const;
type ButtonDefaultAsType = typeof ButtonDefaultAsTypeConst;

type MenuButtonProps<E extends ElementType> = MenuButtonOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof MenuButtonOwnProps<E>>;

const MenuButton = <E extends ElementType = ButtonDefaultAsType>({
  as,
  label,
  HeroIcon,
  customIcon,
  description,
  disabled,
  ...props
}: MenuButtonProps<E>): JSX.Element => {
  const Tag = as || "button";

  return (
    <>
      <Tag
        disabled={disabled}
        {...props}
        className={`w-full  ${
          disabled
            ? "pointer-events-none cursor-not-allowed"
            : "hover:bg-gray-100 cursor-pointer"
        }`}
      >
        <UserMenuItem
          label={label}
          description={description}
          HeroIcon={HeroIcon}
          customIcon={customIcon}
        />
      </Tag>
    </>
  );
};

export const UserMenuItem: FC<MenuItemProps> = ({
  HeroIcon,
  label,
  description,
  customIcon
}) => {
  return (
    <>
      <span
        className={`${userMenuButtonPadding} flex items-center text-sm text-gray-800 text-left bg-transparent`}
      >
        {HeroIcon && <HeroIcon className="fill-gray-400 h-5 w-5 mr-2" />}
        {customIcon && <span className="mr-2">{customIcon}</span>}
        <div className="flex flex-col">
          <span className={`${TEXT_STYLES.body} truncate`}>{label}</span>
          {description && (
            <p className="text-xs text-gray-700">{description}</p>
          )}
        </div>
      </span>
    </>
  );
};

export default MenuButton;
